import { useEffect, useState } from 'react';

import useFirstRender from '@swf/core/hooks/useFirstRender';
import usePrevious from '@swf/core/hooks/usePrevious';
import type { MultipleOpportunity, SingleOpportunity } from '@swf/generated/types/api/sports';

// Animation should be 1000ms but there is 1000ms of CSS animations, so set at 2000ms
const DEFAULT_DURATION = 2000;

/**
 * Returns Boolean based on whether odds have changed within supplied duration
 */
const useHaveOddsChangedWithinDuration = (
  opportunity: SingleOpportunity | MultipleOpportunity,
  duration = DEFAULT_DURATION
) => {
  const firstRender = useFirstRender();
  const [oddsChanging, setOddsChanging] = useState(false);
  const currentOdds =
    'winRunnerOdds' in opportunity
      ? opportunity.winRunnerOdds?.decimalDisplayOdds?.decimalOdds
      : undefined;
  const previousOdds = usePrevious(currentOdds);

  useEffect(() => {
    // !firstRender stops animation when adding to betslip initially)
    if (previousOdds !== currentOdds && !firstRender) {
      setOddsChanging(true);
    }

    const timeout = setTimeout(() => {
      setOddsChanging(false);
    }, duration);

    return () => {
      clearTimeout(timeout);
    };
  }, [currentOdds, duration, firstRender, previousOdds]);

  return {
    haveOddsChangedWithinDuration: oddsChanging
  };
};

export default useHaveOddsChangedWithinDuration;
